import { Api } from "@vzbl/integrations";
import askForQueryRoute from "../api/[orgId]/ask/query.route";
import askForAnythingRoute from "../api/[orgId]/ask/anything.route";
import askFeedbackRoute from "../api/[orgId]/ask/feedback.route";
import { post } from "./lib";

export const askForQuery = (
  orgId: string,
  input: Api.AskQuestion
): Promise<Api.ReceiveQuestionQuery> =>
  post<typeof askForQueryRoute>(`/api/${orgId}/ask/query`, input);

export const askForAnything = (
  orgId: string,
  input: Api.AskQuestion
): Promise<Api.ReceiveQuestionQuery> =>
  post<typeof askForAnythingRoute>(`/api/${orgId}/ask/anything`, input);

export const askFeedback = (
  orgId: string,
  input: Api.AskFeedback
): Promise<void> =>
  post<typeof askFeedbackRoute>(`/api/${orgId}/ask/feedback`, input);
